import { render, staticRenderFns } from "./formDescriptionDebentures.vue?vue&type=template&id=5aed5cb0&scoped=true"
import script from "./formDescriptionDebentures.vue?vue&type=script&lang=js"
export * from "./formDescriptionDebentures.vue?vue&type=script&lang=js"
import style0 from "./formDescriptionDebentures.vue?vue&type=style&index=0&id=5aed5cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed5cb0",
  null
  
)

export default component.exports